import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAdmin } from "@/context/AdminContext";

export default function AdminLogin() {
  const { admin, login } = useAdmin();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin) navigate("/admin/dashboard"); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome, Administrator");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <form onSubmit={submit} className="w-full max-w-md bg-white border border-amber-200 rounded-2xl shadow-lg p-8" data-testid="admin-login-form">
          <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center mx-auto mb-4 ring-2 ring-[#DAA520]/60 overflow-hidden">
            <img src="https://customer-assets-jt897jd0.emergentagent.net/job_temple-booking-hub-4/artifacts/a6054c377532a45a_images.png" alt="TTD Logo" className="w-16 h-16 object-contain" />
          </div>
          <h1 className="font-cinzel text-2xl font-bold text-center text-amber-950">Admin Portal</h1>
          <p className="text-center text-sm text-slate-500 mb-6">Sign in to manage bookings & payments</p>

          <div className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin email" data-testid="admin-email-input" required />
            </div>
            <div>
              <Label>Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password-input" required />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#E65100] hover:bg-[#BF360C] text-white py-6 font-semibold" data-testid="admin-login-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
            </Button>
          </div>
        </form>
      </main>
      <Footer />
    </div>
  );
}
